<template>
  <a-card v-if="getScreen">
    <span slot="title">Petty Cash Form</span>
    <a-steps :current="current" status="process">
      <a-step title="Information" />
      <a-step title="Usage" />
      <a-step title="Approval" />
    </a-steps>
    <div class="steps-content flex-1">
      <component
        class="flex-1"
        :is="steps[current].content"
        :ref="stepRef"
        v-bind="stepProps"
      ></component>
    </div>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button v-if="current < steps.length - 1" type="primary" @click="next"
          >Next</a-button
        >
        <a-button
          v-if="current == (steps.length - 1)"
          type="default"
          :loading="btnLoading"
          @click="validateConfirm"
          :disabled="dataList.length < 1"
          >{{ status === false ? "Save Draft" : "Save" }}</a-button
        >
        <a-button v-if="current > 0" @click="prev">Previous</a-button>
      </div>
    </template>
  </a-card>
  <a-row :gutter="8" v-else>
    <a-col :span="leftcolumn" class="m-page-wrapper">
      <a-card
        :loading="loading"
        class="m-height-full m-display-flex flex-column nowrap"
      >
        <span slot="title">Petty Cash Report Form</span>
        <a-steps :current="current" status="process">
          <a-step title="Information" />
          <a-step title="Usage" />
          <a-step title="Approval" />
        </a-steps>
        <div class="steps-content flex-1">
          <component
            class="flex-1"
            :is="steps[current].content"
            :ref="stepRef"
            v-bind="stepProps"
          ></component>
        </div>
        <template class="ant-card-actions" slot="actions">
          <div class="steps-action">
            <a-button-group>
              <a-button
              v-if="current == 1"
              type="primary"
              @click="handleNew"
              :loading="loadingAdd"
              >Add</a-button
              >
              <a-button
                v-if="current < steps.length - 1"
                type="default"
                @click="next"
                >Next</a-button
              >
              <!-- <a-button
                v-if="current == (steps.length - 1)"
                type="primary"
                :loading="btnLoading"
                @click="validateConfirm"
                :disabled="dataList.length < 1"
                >{{ status === false ? "Save Draft" : "Save" }}</a-button
              >  -->
              <a-button
                v-if="type !== 'revised' && current == steps.length - 1"
                type="default"
                :loading="btnLoading"
                @click="validasiDraft"
                :disabled="disableSaveButton"
                >Save Draft</a-button
              >
              <a-button
                v-if="current == steps.length - 1"
                type="primary"
                :loading="btnLoading"
                @click="validasi"
                :disabled="disableSaveButton"
                >Save</a-button
              >
            </a-button-group>
            <a-button v-if="current > 0" @click="prev">Previous</a-button>
          </div>
        </template>
      </a-card>
    </a-col>
    <a-col :span="rightcolumn" class="m-page-wrapper">
      <a-card class="m-height-full m-display-flex flex-column">
        <div slot="title">
          <span>Reporting Details</span>
        </div>
        <template slot="extra">
          <a-button @click="onCollective" class="margin-right-small" icon="edit"
            >Collective</a-button
          >
          <a-button
            @click="handleExpand()"
            :icon="labelExpand == 'Expand' ? 'arrows-alt' : 'shrink'"
            >{{ labelExpand }}</a-button
          >
        </template>
        <a-table
          :rowKey="(record, index) => {return index;}"
          :columns="columns"
          :dataSource="getCountWeb"
          :pagination="pagination"
          :loading="loadingTable"
          size="small"
          :scroll="{ x: 750 }"
          bordered
        >
          <template slot="title" slot-scope="">
            <div class="H-tb"><b>PETTY CASH</b></div>
          </template>
          <template slot="deskripsi" slot-scope="text, item">
            <span>{{ item.deskripsi }}</span> <br />
            <small>{{ item.end_user ? item.end_user : "-" }}</small>
          </template>
          <template slot="item_anggaran" slot-scope="text, item, index">
            <a-alert
              type="error"
              banner
              v-if="
                item.kredit != '' &&
                (item.item_anggaran == null || item.item_anggaran == '')
              "
              message="item anggaran cannot be empty"
            >
              <!-- <a-icon type="exclamation-circle" /> -->
            </a-alert>
            <template v-else>
              <span>{{ item.item_anggaran }}</span>
              <br />
              <span>{{ item.kode_anggaran }}</span>
            </template>
          </template>
          <template slot="prospect" slot-scope="item">
            <b>{{ item.no_prospek ? item.no_prospek : '-' }}</b> <br/> {{ item.description }}
          </template>
          <template slot="document" slot-scope="index, item">
              <a v-if="item.lampiran" @click="viewlampiranDoc(item.lampiran_path)">
                View Document
              </a>
              <span v-else>
                No File Uploaded
              </span>
            </template>
          <template slot="operation" slot-scope="index, item">
            <a-button-group v-if="item.kredit">
              <a-button type="primary" @click="handleEdit(item,'dtl')" :loading="loadingEdit" :disabled="current!=1">
                <a-icon type="edit" />
              </a-button>
              <a-button type="danger" @click="handleRemoveDetail(item,'dtl')" :disabled="current!=1">
                <a-icon type="close" />
              </a-button>
            </a-button-group>
          </template>

          <template slot="footer">
            <a-row type="flex" v-if="picForColumn === getAuth.username">
              <a-col :span="7" :order="1" class="m-text-align left"
                ><b>Total Petty Cash</b></a-col
              >
              <a-col :span="7" :order="2" class="m-text-align left m-text-bold">
                <CurrencyJustified
                  currencyValue="IDR"
                  :valueNumber="TPC ? TPC : 0"
                />
              </a-col>
              <a-col
                :span="3"
                :order="3"
                class="m-text-align left m-text-bold"
              ></a-col>
            </a-row>
          </template>
        </a-table>
        <a-table
          v-if="dataListBailout.length>0"
          :rowKey="(record, index) => {return index;}"
          :columns="columnsbailout"
          :dataSource="getBiloutWeb"
          :pagination="paginationBailout"
          :loading="loadingTable"
          size="small"
          :scroll="{ x: 500 }"
          bordered
        >
          <template slot="title" slot-scope="">
            <div class="H-tb"><b>BAILOUT</b></div>
          </template>
          <template slot="nopppd" slot-scope="text, item">
            <span>{{ item.no_sppd ? item.no_sppd : "-" }}</span>
          </template>
          <template slot="bailoutvalue" slot-scope="text, item">
            <CurrencyJustified
              currencyValue="IDR"
              :valueNumber="item.bailout_value"
            />
          </template>
          <template slot="operation" slot-scope="index, item">
            <a-button-group>
              <a-button type="primary" @click="handleEdit(item,'Bailout')" :loading="loadingEdit" :disabled="current!=1">
                <a-icon type="edit" />
              </a-button>
              <a-button type="danger" @click="handleRemoveDetail(item,'Bailout')" :disabled="current!=1">
                <a-icon type="close" />
              </a-button>
            </a-button-group>
          </template>
          <template slot="footer">
            <a-row type="flex" v-if="picForColumn === getAuth.username">
              <a-col :span="7" :order="1" class="m-text-align left"
                ><b>Total Bailout</b></a-col
              >
              <a-col :span="7" :order="2" class="m-text-align left m-text-bold">
                <CurrencyJustified
                  v-if="TBL"
                  currencyValue="IDR"
                  :valueNumber="TBL"
                />
              </a-col>
              <a-col
                :span="3"
                :order="3"
                class="m-text-align left m-text-bold"
              ></a-col>
            </a-row>
          </template>
        </a-table>

        <div class="container-essential">
          <a-row type="flex" v-if="picForColumn === getAuth.username">
            <a-col :span="10" :order="1" class="m-text-align left"
              >Total Debit</a-col
            >
            <a-col :span="7" :order="2" class="m-text-align left m-text-bold">
              <CurrencyJustified
                v-if="debit"
                currencyValue="IDR"
                :valueNumber="debit"
              />
            </a-col>
            <a-col
              :span="3"
              :order="3"
              class="m-text-align left m-text-bold"
            ></a-col>
          </a-row>
          <a-row type="flex">
            <a-col :span="10" :order="1" class="m-text-align left"
              >Total Credit (Petty Cash{{ dataListBailout.length>0 ? ' + Bailout' : ''}})</a-col
            >
            <a-col :span="7" :order="2" class="m-text-align left m-text-bold">
              <CurrencyJustified
                v-if="kredit"
                currencyValue="IDR"
                :valueNumber="kredit"
              />
            </a-col>
            <a-col
              :span="3"
              :order="3"
              class="m-text-align left m-text-bold"
            ></a-col>
          </a-row>
          <a-row type="flex" v-if="picForColumn === getAuth.username">
            <a-col :span="10" :order="1" class="m-text-align left"
              >Remaining Balance</a-col
            >
            <a-col :span="7" :order="2" class="m-text-align left m-text-bold">
              <CurrencyJustified
                v-if="getRemainingBalance"
                currencyValue="IDR"
                :valueNumber="getRemainingBalance"
              />
            </a-col>
            <a-col
              :span="3"
              :order="3"
              class="m-text-align left m-text-bold"
            ></a-col>
          </a-row>
        </div>
        <template class="ant-card-actions" slot="actions">
          <div
            class="steps-action"
            v-if="
              current == steps.length - 1 ||
              (mode === 'Edit' && type !== 'draft')
            "
          >
            <a-button
              v-if="current == steps.length - 1"
              type="default"
              :loading="btnLoading"
              @click="validasi"
              :disabled="disableSaveButton"
              >Save</a-button
            >
            <a-button
              v-if="type !== 'revised' && current == steps.length - 1"
              type="default"
              :loading="btnLoading"
              @click="validasiDraft"
              :disabled="disableSaveButton"
              >Save Draft</a-button
            >
          </div>
        </template>
      </a-card>
    </a-col>
    <Modal
      v-if="modal.modalEdit"
      :dataList="dataList"
      :data="modal.data"
      :modalEdit="modal.modalEdit"
      :confirmLoading="modal.confirmLoading"
      :getCostCenter="getCostCenter"
      :getPeruntukan="getPeruntukan"
      :getSubPeruntukan="getSubPeruntukan"
      :getAnggaran="getAnggaran"
      :informasi="collectData.informasi"
      :debit="debit"
      :kredit="kredit"
    />

    <a-modal
      v-if="modal.modalEditBailout"
      v-model="modal.modalEditBailout"
      :title="'Change Bailout'"
      :width="500"
      :maskClosable="false"
      @ok="handleModalEditOkBailout"
      :confirmLoading="modal.confirmLoading"
    >
    <a-form-item required label="Bailout Transaction">
      <a-select
        showSearch
        class="m-width-full"
        v-model="modal.data.id_bailout"
        optionFilterProp="children"
        :filterOption="filterOption"
      >
        <a-select-option v-for="item in comboBailoutFiltered" :key="item.id_bailout">
          <div class="m-display-flex space-between">
            <span>{{ item.no_sppd + " | " + item.tlc_create }}</span>
            <span>{{ formatCurrency('IDR',item.bailout_value) }}</span>
          </div>
        </a-select-option>
      </a-select>
    </a-form-item>
    </a-modal>

    <Collective v-if="isCollective" :close="handleCloseCollective">
      <div slot="title"><a-icon type="edit" />&nbsp;Edit Collective</div>
      <template slot="content">
        <loading v-if="anggaran.loadingtree" />
        <a-form class="margin-bottom" :form="formCollective">
          <a-row :gutter="24">
            <a-col span="12">
              <a-form-item label="Jenis Anggaran">
                <a-select
                  showSearch
                  :not-found-content="null"
                  option-filter-prop="children"
                  v-decorator="[
                    'jenis_anggaran',
                    { rules: [{ required: true }] },
                  ]"
                  @change="handleJenisAnggaran"
                >
                  <a-select-option
                    v-for="item in getJenisAnggaran"
                    :key="item.value"
                    >{{ item.text }}</a-select-option
                  >
                </a-select>
              </a-form-item>
              <a-form-item label="Cost Center">
                <a-select
                  :disabled="costCenter.length == 0"
                  showSearch
                  v-decorator="['cost_center', { rules: [{ required: true }] }]"
                  @change="handleCost"
                >
                  <a-select-option v-for="item in costCenter" :key="item.value"
                    >{{ item.text }} ({{
                      item.nama_pekerjaan ? item.nama_pekerjaan : "-"
                    }})</a-select-option
                  >
                </a-select>
              </a-form-item>
            </a-col>
            <a-col span="12">
              <a-form-item label="Peruntukan">
                <a-select
                  :disabled="peruntukan.length == 0"
                  showSearch
                  v-decorator="['peruntukan', { rules: [{ required: true }] }]"
                  @change="handlePeruntukan"
                  optionFilterProp="children"
                  :filterOption="filterOption"
                >
                  <a-select-option
                    v-for="item in peruntukan"
                    :key="item.value"
                    >{{ item.text }}</a-select-option
                  >
                </a-select>
              </a-form-item>
              <a-form-item label="Kode Anggaran">
                <a-tree-select
                  v-decorator="[
                    'kode_anggaran',
                    { rules: [{ required: true }] },
                  ]"
                  show-search
                  style="width: 100%"
                  @select="handlechoiceCost"
                  :dropdown-style="{ maxWidth: '200px', maxHeight: '400px' }"
                  :tree-data="anggaran.tree"
                  treeNodeFilterProp="children"
                  :filterTreeNode="filterTreeNode"
                  placeholder="Please select"
                  allow-clear
                  :treeExpandedKeys="treeExpandedKeys"
                  :disabled="
                    anggaran.loadingtree ||
                    anggaran.tree == undefined ||
                    anggaran.tree.length == 0
                  "
                >
                  <div slot="title" slot-scope="item">
                    <div class="tree-between">
                      <div class="m-text-dots">
                        <span>{{ item.texttitle }}</span>
                        <small>( {{ item.kode_anggaran }} )</small>
                      </div>
                      <span>{{ formatRupiah(parseFloat(item.rekap)) }}</span>
                    </div>
                  </div>
                </a-tree-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <a-table
          :columns="columns"
          :rowKey="(record, index) => {return index;}"
          :dataSource="getCountWeb"
          :pagination="pagination"
          size="small"
          :scroll="{ x: 750 }"
          bordered
        >
          <template slot="deskripsi" slot-scope="text, item">
            <span>{{ item.deskripsi }}</span> <br />
            <small>{{ item.end_user ? item.end_user : "-" }}</small>
          </template>
          <template slot="item_anggaran" slot-scope="text, item">
            <a-alert
              type="error"
              banner
              v-if="
                item.kredit != '' &&
                (item.item_anggaran == null || item.item_anggaran == '')
              "
              message="item anggaran cannot be empty"
            ></a-alert>
            <template v-else>
              <span>{{ item.item_anggaran }}</span>
              <br />
              <span>{{ item.kode_anggaran }}</span>
            </template>
          </template>
          <template slot="prospect" slot-scope="item">
            <b>{{ item.no_prospek ? item.no_prospek : '-' }}</b> <br/> {{ item.description }}
          </template>
          <template slot="document" slot-scope="index, item">
            <a v-if="item.lampiran" @click="viewlampiranDoc(item.lampiran_path)">
              View Document
            </a>
            <span v-else>
              No File Uploaded
            </span>
          </template>
          <template slot="operation" slot-scope="a, item, index">
            <a-checkbox
              v-if="item.kredit"
              :checked="
                selectedTree.filter((obj) => obj.id == item.id).length == 0
                  ? false
                  : true
              "
              @change="handleCheck"
              :value="item"
            ></a-checkbox>
          </template>
        </a-table>
      </template>
      <a-button-group slot="action">
        <a-button
          @click="handleSet"
          type="primary"
          :disabled="selectedTree.length == 0"
          >Set</a-button
        >
        <a-button
          @click="handleCloseCollective"
          :type="selectedTree.length == 0 ? 'primary' : ''"
          >Done</a-button
        >
      </a-button-group>
    </Collective>
  </a-row>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import Informasi from "./steps/InformasiKasKecil.vue";
import Pemakaian from "./steps/PemakaianKasKecil.vue";
import Approval from "./steps/Persetujuan.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import nanoid from "nanoid";
import Modal from "./Modal.vue";
import moment from "moment";
import _ from "lodash";
import Collective from "@/components/collective/Collective.vue";
import Loading from "@/components/preloader/Loading.vue";
import CollectiveKas from "@/mixins/collective/collectiveKas";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import { forEach } from "lodash";

export default {
  name: "CreateKasKecil",
  props: ["id", "type"],
  components: {
    Informasi,
    Pemakaian,
    Modal,
    Collective,
    Loading,
    Approval,
  },
  mixins: [CurrencyFormat, CollectiveKas, GlobalMethod],
  data() {
    return {
      loading: true,
      current: 0,
      steps: [
        {
          title: "Informasi",
          content: "Informasi",
        },
        {
          title: "Pemakaian",
          content: "Pemakaian",
        },
        {
          title: "Approval",
          content: "Approval",
        },
      ],
      collectData: {},
      mode: "Create",
      id_kas: "",
      active: false,
      status: false,
      dataList: [],
      dataListBailout: [],
      comboBailout: [],
      comboBailoutFiltered: [],
      url: "",
      debit: 0,
      kredit: 0,
      mata_uang: "",
      sisa_saldo: 0,
      pageLoading: true,
      pagination: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
      paginationBailout: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
      btnLoading: false,
      modal: {
        id_bailout_old: "",
        modalEdit: false,
        modalEditBailout: false,
        confirmLoading: false,
        confirm: false,
        data: {
          tanggal_pemakaian: moment().format(),
          deskripsi: "",
          kredit: "",
          id: "",
          alokasi: "",
          proyek: "",
        },
      },
      picForColumn: "",
      leftcolumn: 12,
      rightcolumn: 12,
      labelExpand: "Expand",
      loadingTable: false,
      loadingAdd: false,
      loadingEdit: false,
    };
  },
  created() {
    this.$store.dispatch("FETCH_COST_CENTER");
    this.id_kas = nanoid(11);
    this.fetch();
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getCostCenter",
      "getPeruntukan",
      "getSubPeruntukan",
      "getAnggaran",
    ]),
    stepProps: function () {
      if (this.mode === "Edit") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            data: this.collectData.informasi,
            others: this.collectData.others,
            mode: this.mode,
            active: this.active,
            id_kas: this.id_kas,
            dataList: this.dataList,
          };
        } else if (this.steps[this.current].content === "Pemakaian") {
          return {
            data: this.collectData.pemakaian,
            informasi: this.collectData.informasi,
            id_kas: this.collectData.others.id_kas
              ? this.collectData.others.id_kas
              : this.id,
            mode: this.mode,
            dataList: this.dataList,
            dataListBailout: this.dataListBailout,
            debit: this.debit,
            kredit: this.kredit,
            mata_uang: this.mata_uang,
            url: this.url,
            type: this.type,
          };
        } else {
          return {
            collectData: this.collectData,
            mode: this.mode,
            dataList: this.dataList,
            listAppr: this.collectData.approval,
            id: this.id,
            type: this.type,
          };
        }
      } else if (this.mode === "Create") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            data: this.collectData.informasi,
            others: this.collectData.others,
            mode: this.mode,
            active: this.active,
            id_kas: this.id,
            dataList: this.dataList,
          };
        } else if (this.steps[this.current].content === "Pemakaian") {
          if (this.type === "draft") {
            return {
              data: this.collectData.pemakaian,
              informasi: this.collectData.informasi,
              id_kas: this.id,
              mode: this.mode,
              dataList: this.dataList,
              dataListBailout: this.dataListBailout,
              debit: this.debit,
              kredit: this.kredit,
              mata_uang: this.mata_uang,
              url: this.url,
            };
          } else {
            return {
              data: this.collectData.pemakaian,
              informasi: this.collectData.informasi,
              id_kas: this.id_kas,
              mode: this.mode,
              dataList: this.dataList,
              debit: this.debit,
              kredit: this.kredit,
              mata_uang: this.mata_uang,
              url: this.url,
            };
          } 
        } else {
          return {
            collectData: this.collectData,
            mode: this.mode,
            dataList: this.dataList,
            listAppr: this.collectData.approval,
            type: this.type,
            id: this.id
          };
        }
      }
      return true;
    },
    stepRef: function () {
      if (this.steps[this.current].content === "Informasi") {
        return "refInformasi";
      } else if (this.steps[this.current].content === "Pemakaian") {
        return "refPemakaian";
      } else if (this.steps[this.current].content === "Approval"){
        return "refApproval";
      }
      return true;
    },
    columns() {
      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 60,
          align: "center",
          sorter: (a, b) => a.no - b.no,
          fixed: "left",
        },
        {
          title: "Date",
          dataIndex: "tanggal",
          width: 110,
          key: "tanggal",
          sorter: (a, b) =>
            new Date(
              moment(a.tanggal, this.getDefaultDateFormat).format(
                this.getStandartFormatDate
              )
            ) -
            new Date(
              moment(b.tanggal, this.getDefaultDateFormat).format(
                this.getStandartFormatDate
              )
            ),
        },
        {
          title: "Description",
          key: "deskripsi",
          width: 200,
          scopedSlots: { customRender: "deskripsi" },
          sorter: (a, b) => a.deskripsi.length - b.deskripsi.length,
        },
        {
          title: "Item Anggaran",
          key: "item_anggaran",
          width: 250,
          scopedSlots: { customRender: "item_anggaran" },
          sorter: (a, b) => a.item_anggaran.length - b.item_anggaran.length,
        },
        {
          title: "Prospect",
          key: "prospect",
          width: 250,
          scopedSlots: { customRender: "prospect" },
          sorter: (a, b) => a.no_prospek - b.no_prospek,
        },
        {
          title: "Document",
          key: "document",
          scopedSlots: { customRender: "document" },
          width: 150,
          align: "center"
        },
        {
          title: "Debit",
          dataIndex: "debit_value",
          key: "debit_value",
          align: "right",
          width: 170,
          sorter: (a, b) => a.debit.length - b.debit.length,
        },
        {
          title: "Credit",
          dataIndex: "kredit_value",
          key: "kredit_value",
          align: "right",
          width: 170,
          sorter: (a, b) => a.kredit.length - b.kredit.length,
        },
        {
          title: "Balance",
          dataIndex: "sisa",
          key: "sisa",
          align: "right",
          width: 170,
          sorter: (a, b) => a.sisa.length - b.sisa.length,
        },
        {
          title: this.isCollective ? "Check" : "Action",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          width: this.isCollective ? 90 : 110,
          align: "center",
          fixed: "right",
        },
      ];

      if (this.picForColumn !== this.getAuth.username) {
        //kolom.splice(5, 1);
        kolom.splice(6, 1);
      }
      return kolom;
    },
    columnsbailout() {
      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 60,
          align: "center",
          sorter: (a, b) => a.no - b.no,
        },
        {
          title: "No PP/PD Transaction",
          key: "nopppd",
          scopedSlots: { customRender: "nopppd" },
          sorter: (a, b) => a.no_sppd - b.no_sppd,
        },
        {
          title: "Bailout Value",
          key: "bailoutvalue",
          align: "right",
          scopedSlots: { customRender: "bailoutvalue" },
          sorter: (a, b) => a.bailout_value - b.bailout_value,
        },
        {
          title: this.isCollective ? "Check" : "Action",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          width: this.isCollective ? 90 : 110,
          align: "center",
          fixed: "right",
        },
      ];

      if (this.picForColumn !== this.getAuth.username) {
        //kolom.splice(5, 1);
        kolom.splice(6, 1);
      }
      return kolom;
    },
    getCountWeb() {
      let data = this.dataList;
      let debit = 0;
      if (data) {
        data.forEach((value, index) => {
          if (value.debit !== "") {
            debit += value.debit;
            data[index]["debit_value"] = this.formatCurrency(
              this.mata_uang,
              value.debit
            );
            data[index]["sisa"] = this.formatCurrency(this.mata_uang, debit);
          } else {
            data[index]["debit_value"] = "-";
          }

          data[index]["no"] = index + 1;
          data[index]["key"] = index;
          //
          if (value.kredit !== "") {
            data[index]["kredit_value"] = this.formatCurrency(
              this.mata_uang,
              value.kredit
            );
            debit -= value.kredit;
            data[index]["sisa"] = this.formatCurrency(this.mata_uang, debit);

            data[index]["sisa_value"] = debit;
          } else {
            data[index]["kredit_value"] = "-";
          }
          data[index]["tanggal"] = moment(
            value.tanggal_pemakaian,
            this.getStandartFormatDate
          ).format(this.getDefaultDateFormat);
        });
      }
      return data;
    },
    getBiloutWeb(){
      let data = this.dataListBailout;
      // let debit = 0;
      if (data) {
        data.forEach((value, index) => {
          // if (value.debit !== "") {
          //   debit += value.debit;
          //   data[index]["debit_value"] = this.formatCurrency(
          //     this.mata_uang,
          //     value.debit
          //   );
          //   data[index]["sisa"] = this.formatCurrency(this.mata_uang, debit);
          // } else {
          //   data[index]["debit_value"] = "-";
          // }

          data[index]["no"] = index + 1;
          // data[index]["key"] = index;
          // //
          // if (value.kredit !== "") {
          //   data[index]["kredit_value"] = this.formatCurrency(
          //     this.mata_uang,
          //     value.kredit
          //   );
          //   debit -= value.kredit;
          //   data[index]["sisa"] = this.formatCurrency(this.mata_uang, debit);

          //   data[index]["sisa_value"] = debit;
          // } else {
          //   data[index]["kredit_value"] = "-";
          // }
          data[index]["tanggal"] = moment(
            value.tanggal_pemakaian,
            this.getStandartFormatDate
          ).format(this.getDefaultDateFormat);
        });
      }
      return data;
    },
    getRemainingBalance() {
      return (this.dataList !== undefined
        ? this.dataList.length > 0
          ? Number(this.dataList[this.dataList.length - 1].sisa_value)
          : 0
        : 0) - 
        (this.dataListBailout !== undefined
        ? this.dataListBailout.length > 0
          ? _.sumBy(this.dataListBailout, function (val) {
              return Number(val.bailout_value)
            })
          : 0
        : 0)
        ;
    },
    disableSaveButton() {
      let result = this.labelExpand == "Collapse";
      if (result) {
        result = true;
      } else {
        result = this.dataList.length < 1;
      }
      return result;
    },
    TPC(){
      return _.sumBy(this.dataList, function (val) {
        return Number(val.kredit)
      });
    },
    TBL(){
      return _.sumBy(this.dataListBailout, function (val) {
        return Number(val.bailout_value)
      });
    },
  },
  methods: {
    moment,
    fetch() {
      if (this.id) {
        this.mode = "Edit";
        if (this.type === "draft") {
          this.status = false;
          this.url = this.$serviceUrl + "kas_kecil/detil_pemakaian";
          this.fetchEdit(this.url);
        } else {
          this.url = this.$serviceUrl + "kas_kecil/revisi_detil_pemakaian";
          this.fetchEdit(this.url);
          this.type = "revised";
          this.status = true;
        }
      } else if (this.mode === "Create") {
        this.url = this.$serviceUrl + "kas_kecil/detil_pemakaian";
        this.loading = false;
      }

      if (this.id && this.mode === "Edit" && !this.getScreen && this.loading) {
        this.fetchPemakaian();
      }
    },
    ...mapActions(["FETCH_ALLOCATION", "FETCH_USEDFOR"]),
    next() {
      if (this.steps[this.current].content === "Informasi") {
        this.$refs.refInformasi.handleRef();
      } else if (this.steps[this.current].content === "Pemakaian") {
        let isOnlyBailout = this.getBiloutWeb.length>0 && this.getCountWeb.length==1 ? true : false;
        if (this.dataList.length<=1 && !isOnlyBailout){
          this.displayMessageValue(
          "error-other",
          "Data Details can't be empty, because this transaction has at least 1 data!"
        );
        }else{
          this.getApproval();
        }
      }
    },
    prev() {
      if(this.steps[this.current].content === "Approval"){
        this.$refs.refApproval.handleRef();
        this.expandcolumn("collapse");
      }
      this.current--;
    },
    validasi() {
      if (!this.getScreen) {
        this.status = true;
      } else {
        this.status = false;
      }
      if (this.mode === "Edit") {
        this.confirmMessage("confirm-edit");
      } else {
        this.confirmMessage("confirm-save");
      }
    },
    validasiDraft() {
      this.confirmMessage("confirm-save-draft");
    },
    validateConfirm(){
      this.$refs.refApproval.handleRef();
      if (this.mode === "Edit") {
        this.confirmMessage("confirm-edit");
      } else {
        this.confirmMessage("confirm-save");
      }
    },
    validate() {
      this.$refs.refApproval.handleRef();
      this.btnLoading = true;
      if (this.status) {
        let postData;
        let method;
        let contentType;
        let link;
        if (this.type === "revised") {
          method = "put";
          contentType = "application/json";
          link = "/pu/kk/" + this.collectData.others.id_kas;
          postData = {
            tlc: this.getAuth.username,
            id_kas: this.id,
            approval_pic: this.collectData.informasi.pic,
            approval_bod: this.collectData.informasi.bod,
            tanggal_pelaporan:
              this.collectData.informasi.tanggal_pelaporan.format("YYYY-MM-DD"),
            public_manifest_url: link,
            catatan: this.collectData.informasi.catatan ? 
              this.collectData.informasi.catatan : '',
          };
        } else {
          method = "post";
          contentType = "multipart/form-data";
          postData = new FormData();
          link = "/pu/kk/" + this.id_kas;

          if (this.mode === "Edit") {
            postData.append("id_kas", this.collectData.others.id_kas);
          } else {
            postData.append("id_kas", this.id_kas);
          }
          postData.append("tlc", this.getAuth.username);
          postData.append("approval_pic", this.collectData.informasi.pic);
          postData.append("approval_bod", this.collectData.informasi.bod);
          postData.append(
            "tanggal_pelaporan",
            this.collectData.informasi.tanggal_pelaporan.format("YYYY-MM-DD")
          );
          postData.append("public_manifest_url", link);
          postData.append("catatan", this.collectData.informasi.catatan ? 
              this.collectData.informasi.catatan : '');
        }
        axios({
          method: method,
          url: this.$serviceUrl + "kas_kecil",
          data: postData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": contentType,
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.displayMessage("success-save");
            this.btnLoading = false;
            this.$router.push({ name: "laporanKasKecil" });
          })
          .catch((err) => {
            let response = Object.assign({}, err.response);
            if (
              response.data.message.includes("Tidak Memiliki Detil Pemakaian")
            ) {
              this.displayMessageValue(
                "error-notif-kaskecil",
                response.data.message
              );
            } else {
              this.status = false;
              let responses = Object.assign({}, err.response);
              if (responses.data) {
                this.displayMessageValue("error-other", responses.data.message);
              } else {
                this.displayMessageValue("error", responses);
              }
            }
            this.btnLoading = false;
          });
      } else {
        axios({
          method: "POST",
          url: this.$serviceUrl + "kas_kecil/draft",
          data: {
            id_kas: this.id,
            catatan: this.collectData.informasi.catatan,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
        this.$router.push({ name: "laporanKasKecil" });
      }
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "Informasi") {
        this.collectData.informasi = value;
        this.current++;
      } else if (this.steps[this.current].content === "Persetujuan") {
        this.collectData.persetujuan = JSON.parse(
          JSON.stringify(value.persetujuan)
        );
        this.current++;
      }else if (this.steps[this.current].content === "Approval") {
        this.collectData.informasi.catatan = value.note
      }
    },
    controlForm(value) {
      this.active = value;
    },
    draftStatus(val) {
      this.status = val;
    },
    fetchEdit(url) {
      axios({
        method: "get",
        url: url,
        params: {
          id_kas: this.id,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.collectData = {
            informasi: {
              tanggal_pelaporan: response.data.tanggal_pelaporan,
              type: response.data.type_kas == "N" ? "nonbod" : "bod",
              catatan: response.data.catatan,
            },
            others: {
              mata_uang: response.data.mata_uang,
              id_kas: response.data.id_kas,
              total_kredit: response.data.total_kredit,
            },
          };
          this.dataList = response.data.detail_pemakaian
            ? response.data.detail_pemakaian
            : new Array();
          this.loading = false;
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response);
          this.displayMessageValue("error", responses);
          // this.$router.go(-1);
        });
    },
    fetchPemakaian() {
      let id_kas;
      this.loadingAdd = true;
      if (this.type === "revised" || this.type === "draft") {
        id_kas = this.id;
      } else {
        id_kas = this.id_kas;
      }

      if (!this.getScreen) {
        axios({
          method: "get",
          url: this.url,
          params: {
            tlc: this.getAuth.username,
            id_kas: id_kas,
            mode: this.mode,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.dataList = response.data.detail_pemakaian
              ? response.data.detail_pemakaian
              : new Array();
            this.dataListBailout = response.data.detail_bailout ? response.data.detail_bailout : [];

            this.kredit = response.data.total_kredit;
            this.debit = response.data.total_debit;
            this.mata_uang = response.data.mata_uang;
            if (this.dataList.length === 1) {
              this.active = false;
            }
            this.loadingTable = false;
            this.$refs.refPemakaian.done();
            this.loadingAdd = false;
          })
          .catch((err) => {
            let response = Object.assign({}, err.response);
            if (response.message === "Tidak Memiliki Detil Pemakaian") {
              this.active = false;
              this.mode = "Create";
              this.dataList = [];
              this.debit = 0;
              this.kredit = 0;

              if (this.type === "draft") {
                this.$router.go(-1);
              }

              this.$refs.refPemakaian.done();

              if (this.mode !== "Create") {
                this.displayMessageValue(
                  "error-notif-kaskecil",
                  response.message
                );
              }
            }
            this.loadingTable = false;
            this.loading = false;
            this.loadingAdd = false;
          });
      } else {
        if (this.steps[this.current].content === "Pemakaian") {
          axios({
            method: "get",
            url: this.url,
            params: {
              tlc: this.getAuth.username,
              id_kas: id_kas,
            },
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.dataList = response.data.detail_pemakaian
                ? response.data.detail_pemakaian
                : new Array();
              this.kredit = response.data.total_kredit;
              this.debit = response.data.total_debit;
              this.mata_uang = response.data.mata_uang;
              this.$refs.refPemakaian.done();
              if (this.dataList.length === 1) {
                this.active = false;
              }
              this.loadingAdd = false;
            })
            .catch((err) => {
              if (
                err.response.data.message === "Tidak Memiliki Detil Pemakaian"
              ) {
                // this.current = 0;
                this.active = false;
                // this.mode = "Create";
                this.$refs.refPemakaian.done();
              } else {
              }
              this.loading = false;
              this.loadingAdd = false;
            });
        }
      }
    },
    handleCheckData(e) {
      this.draftStatus(e.target.checked);
    },
    handleNew() {
      this.$refs.refPemakaian.handleNew();
    },
    handleEdit(item, jns) {
      if(jns=='Bailout'){
        this.modal.data = {
          id_bailout_old: item.id_bailout,
          id_bailout: item.id_bailout,
          id_kas: item.id_kas,
          approval_pic: this.getAuth.username,
          tanggal_pelaporan: this.collectData.informasi.tanggal_pelaporan,
          type_kas: this.collectData.informasi.type=='nonbod' ? 'N' : 'B'
        }
        this.comboBailoutFiltering(item.id_bailout);
        this.modal.modalEditBailout = true;
      }else{
        let angcode =
          item.peruntukan_id +
          ";" +
          item.sub_peruntukan_id +
          ";" +
          item.kode_anggaran_id;
        this.modal.data = {
          path: item.path,
          anggaran_code: angcode == "null;null;null" ? undefined : angcode,
          tanggal_pemakaian: item.tanggal_pemakaian,
          deskripsi: item.deskripsi,
          kredit: item.kredit,
          id: item.id,
          id_kas: this.id,
          type: this.type,
          alokasi: item.alokasi,
          cost_center_id: item.cost_center_id,
          peruntukan_id: item.peruntukan_id,
          sub_peruntukan_id: item.sub_peruntukan_id,
          kode_anggaran_id: item.kode_anggaran_id,
          jns_anggaran_id: item.jns_anggaran_id,
          end_user:
            item.end_user !== null
              ? item.end_user.substring(0, 3).toUpperCase()
              : null
        };

        if(item.prospek){
          this.modal.data['prospek'] = item.prospek
        }

        if (item.lampiran) {
          this.loadingEdit = true;
          this.asyncAxiosGet("main/base_64", this.getAuth, {
            path: item.lampiran_path,
          })
            .then((response) => {
              let typefile = this.fileTypeFromUrl(item.lampiran);
              let file = this.dataURLtoFile(
                typefile + response.file_document_tax,
                item.lampiran
              );
              file.uid = "vc-upload-1-1";
              file.status = "done";
              file.url = this.$serviceUrl + item.lampiran_path;
              this.modal.data.doctransfiles = [];
              this.modal.data.doctransfiles.push(file);

              this.modal.modalEdit = true;
              this.loadingEdit = false;
              this.modal.type = this.type;
            })
            .catch((err) => {
              this.loadingEdit = false;
              console.log(err);
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error-other", responses.message);
            });
        } else {
          this.modal.modalEdit = true;
          this.modal.type = this.type;
        }
      }
    },
    handleCancel(e) {
      this.modal.modalEdit = false;
      if (this.$refs.refPemakaian) {
        this.$refs.refPemakaian.recountingAnggaran(this.dataList);
      }
    },
    handleRemoveDetail(item, jns) {
      item['type_delete'] = jns
      if (this.dataList.length > 2) {
        this.confirmMessageValue("confirm-delete", item);
      } else {
        if (this.type === "draft" || this.type == undefined) {
          //this.confirmMessageValue("confirm-delete", item);
          this.confirmMessageValue("confirm-delete-clear", item);
        } else {
          this.displayMessageValue("delete-cancel",item);
        }
      }
    },
    deleteClear(item) {
      this.delete(item);
      // if(this.mode!=="Create" && this.datalist.length==0){
      //       this.$router.go();
      //     }
    },
    delete(item) {
      const serviceUrl = this.$serviceUrl;
      let url =
        this.type === "revised"
          ? (item.type_delete=='Bailout' ? "kas_kecil/bailout" : "kas_kecil/revisi_detil_pemakaian")
          : (item.type_delete=='Bailout' ? "kas_kecil/bailout" : "kas_kecil/detil_pemakaian");
      const auth = {
        username: this.getAuth.username,
        password: this.getAuth.password,
        apikey: this.getAuth.apikey,
      };
      this.loadingTable = true;
      axios({
        method: "delete",
        url: serviceUrl + url,
        processData: false,
        data: item.type_delete=='Bailout' ?
        {
          id_kas: item.id_kas,
          id_bailout: item.id_bailout,
          approval_pic: this.getAuth.username
        }
        :
        {
          id: item.id,
        },
        auth: {
          username: auth.username,
          password: auth.password,
        },
        headers: {
          "X-API-KEY": auth.apikey,
        },
      })
        .then((response) => {
          if (
            response.data.message === "Berhasil Delete Detil Pemakaian" &&
            this.dataList.length == 2
          ) {
            this.$router.push({ name: "laporanKasKecil" });
          } else {
            if (this.$refs.refPemakaian) {
              this.$refs.refPemakaian.resetFormPemakaian();
            }
            Event.$emit("fetchPemakaian", 0);
            Event.$emit("getComboBailouts", 'ontrans');
          }
        })
        .catch((err) => {
          console.log(err);
          this.loadingTable = false;
        });
    },
    switchMode(value) {
      this.mode = value;
    },
    getPicMode(value) {
      this.picForColumn = value;
    },
    handleExpand() {
      if (this.leftcolumn == 12 && this.rightcolumn == 12) {
        this.leftcolumn = 0;
        this.rightcolumn = 24;
        this.labelExpand = "Collapse";
        this.pagination.pageSize = 10;
      } else {
        this.leftcolumn = 12;
        this.rightcolumn = 12;
        this.labelExpand = "Expand";
        this.pagination.pageSize = 5;
      }
    },
    handleLoading(value) {
      this.loadingAdd = value;
    },
    onCancel() {
      this.status = false;
    },
    async getApproval(){
      let params = {};
      if (this.mode=="Create"){
        params = { 
          tlc : this.getAuth.username,
          approval_pic : this.collectData.informasi.pic,
          approval_bod : this.collectData.informasi.bod,
          type_kas : this.collectData.informasi.type=="bod" ? 'b' :'n',
          is_draft : this.type=='revised' ? 0 : 1,
        };
    }else{
      params = { tlc : this.getAuth.username,
          approval_pic : this.collectData.informasi.pic,
          approval_bod : this.collectData.informasi.bod,
          type_kas : this.collectData.informasi.type=="bod" ? 'b' :'n',
          is_draft : this.type === "draft" ? '1' :'0',
          id_kas: this.id,
        };
    }

      await axios({
        method: 'get',
        url: this.$serviceUrl + "kas_kecil/approval",
        processData: false,
        params: params,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.collectData.approval=response.data.data;
          this.expandcolumn("expand");
          this.current++;
        })
        .catch(err => {
          let responses = Object.assign({}, err.response);
          this.displayMessageValue("error", responses);
        });
    },
    expandcolumn(val){
      if(val=="expand"){
          this.leftcolumn = 24;
          this.rightcolumn = 0;
      }else{
          this.leftcolumn = 12;
          this.rightcolumn = 12;
      }
    },
    viewlampiranDoc(url) {
      window.open(this.$serviceUrl + url, "_blank");
    },
    toBailoutList(value){
      this.comboBailout = value;
    },
    comboBailoutFiltering(val){
      let result = this.comboBailout
      this.dataListBailout.forEach(element => {
        if(element.id_bailout!=val)
          result = _.filter(result, item => item.id_bailout!=element.id_bailout)
      });
      this.comboBailoutFiltered = result
    },
    handleModalEditOkBailout(){
      let nilaiBailoutEdited = this.dataListBailout.filter(item=>item.id_bailout==this.modal.data.id_bailout_old)
      let selectedBailoitEdited = this.comboBailoutFiltered.filter(item=>item.id_bailout==this.modal.data.id_bailout)
      let res = ((this.debit?this.debit:Number(selectedBailoitEdited[0].bailout_value))-((this.kredit?this.kredit:0)-Number(nilaiBailoutEdited[0].bailout_value))+Number(selectedBailoitEdited[0].bailout_value)) > 0 ? false : true
      if(res){
        this.displayMessageValue("error-other", "Calculate Grand total can't be minus!");
        return;
      }

      this.modal.confirmLoading = true
      axios({
        method: "POST",
        url: this.$serviceUrl + "kas_kecil/bailout",
        data: {
          id_kas: this.id,
          id_bailout: this.modal.data.id_bailout,
          id_bailout_old: this.modal.data.id_bailout_old,
          approval_pic: this.collectData.informasi.pic,
          tanggal_pelaporan:
            this.collectData.informasi.tanggal_pelaporan.format("YYYY-MM-DD"),
          type_kas: this.collectData.informasi.type=='nonbod' ? 'N' : 'B'
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).then(()=>{
        this.modal.confirmLoading = false
        this.modal.modalEditBailout = false
        this.displayMessageValue("success-other", 'Bailout Has been Updated!');
        if (this.$refs.refPemakaian) {
          this.$refs.refPemakaian.resetFormPemakaian();
        }
        Event.$emit("fetchPemakaian", 0);
        Event.$emit("getComboBailouts", 'ontrans');
      })
    }
  },
  mounted() {
    this.FETCH_ALLOCATION();
    this.FETCH_USEDFOR();
    Event.$on("lapUmpd", this.valueFromChild);
    Event.$on("disableInformasi", this.controlForm);
    Event.$on("draftStatus", this.draftStatus);
    Event.$on("fetchPemakaian", this.fetchPemakaian);
    Event.$on("modalCancel", this.handleCancel);
    Event.$on("removeDetail", this.handleRemoveDetail);
    Event.$on("switchMode", this.switchMode);
    Event.$on("confirmMessageReturn", this.validate);
    Event.$on("confirmMessageDelete", this.delete);
    Event.$on("confirmMessageDeleteClear", this.deleteClear);
    Event.$on("getPicUser", this.getPicMode);
    Event.$on("handleLoading", this.handleLoading);
    Event.$on("confirmMessageCancel", this.onCancel);
    Event.$on("ismobileSaveLapumpp",this.handleCheckData);
    Event.$on("listBailoutToParent",this.toBailoutList);
  },
  beforeDestroy() {
    Event.$off("lapUmpd", this.valueFromChild);
    Event.$off("disableInformasi", this.controlForm);
    Event.$off("draftStatus", this.draftStatus);
    Event.$off("fetchPemakaian", this.fetchPemakaian);
    Event.$off("modalCancel", this.handleCancel);
    Event.$off("removeDetail", this.handleRemoveDetail);
    Event.$off("confirmMessageReturn", this.validate);
    Event.$off("confirmMessageDelete", this.delete);
    Event.$off("confirmMessageDeleteClear", this.deleteClear);
    Event.$off("getPicUser", this.getPicMode);
    Event.$off("ismobileSaveLapumpp",this.handleCheckData);
    Event.$off("listBailoutToParent",this.toBailoutList);
  },
};
</script>

<style lang="less" scoped>
.tree-between {
  display: flex;
  justify-content: space-between;
}
.m-text-dots {
  width: 60%;
}

.H-tb{
  color : @color-secondary;
  text-align: center;
}
</style>
